import { ROLE_WILDCARD_PUBLIC, UnespCoreMenuItem } from '@unesp/core'

export const menu: UnespCoreMenuItem[] = [
  // DEPARTAMENTO (Chefe e Assessor)
  {
    displayName: 'Departamento',
    iconName: 'menu',
    roles: ['DEPARTAMENTO', 'ASSESSOR'],
    order: 1,
    addBottomDivider: true,
    children: [
      {
        displayName: 'Informações e procedimentos',
        iconName: 'content_paste',
        roles: ['DEPARTAMENTO', 'ASSESSOR'],
        order: 100,
        route: '/departamento/informacao-procedimento',
      },
      {
        displayName: '1: Liberar disciplina',
        iconName: 'school',
        roles: ['DEPARTAMENTO', 'ASSESSOR'],
        order: 101,
        route: '/departamento/liberar-disciplina',
      },
      {
        displayName: '2: Aprovar inscrição',
        iconName: 'list_alt',
        roles: ['DEPARTAMENTO', 'ASSESSOR'],
        order: 102,
        route: '/departamento/aprovar-inscricao',
      },
      {
        displayName: '3: Aprovar plano de atividades',
        iconName: 'checklist',
        roles: ['DEPARTAMENTO', 'ASSESSOR'],
        order: 103,
        route: '/departamento/aprovar-plano',
      },
      {
        displayName: '4: Homologar relatório de atividades',
        iconName: 'gavel',
        roles: ['DEPARTAMENTO', 'ASSESSOR'],
        order: 104,
        route: '/departamento/homologar-relatorio',
      },
      {
        displayName: 'Consulta',
        iconName: 'search',
        roles: ['DEPARTAMENTO', 'ASSESSOR'],
        order: 105,
        children: [
          {
            displayName: 'Disciplinas liberadas',
            iconName: 'library_books',
            roles: ['DEPARTAMENTO', 'ASSESSOR'],
            order: 106,
            route: '/departamento/disciplina-liberada',
          },
          {
            displayName: 'Planos de atividades entregues',
            iconName: 'task',
            roles: ['DEPARTAMENTO', 'ASSESSOR'],
            order: 107,
            route: '/departamento/plano-entregue',
          },
          {
            displayName: 'Relatórios de atividades entregues',
            iconName: 'task',
            roles: ['DEPARTAMENTO', 'ASSESSOR'],
            order: 108,
            route: '/departamento/relatorio-entregue',
          },
          {
            displayName: 'Status das inscrições',
            iconName: 'check_circle',
            roles: ['DEPARTAMENTO', 'ASSESSOR'],
            order: 109,
            route: '/departamento/status-inscritos',
          },
        ],
      },
    ],
  },
  // DOCENTE
  {
    displayName: 'Docente',
    iconName: 'menu',
    roles: ['DOCENTE'],
    order: 2,
    addBottomDivider: true,
    children: [
      {
        displayName: 'Informações e procedimentos',
        iconName: 'content_paste',
        roles: ['DOCENTE'],
        order: 200,
        route: '/docente/informacao-procedimento',
      },
      {
        displayName: '1: Aprovar carga horária',
        iconName: 'gavel',
        roles: ['DOCENTE'],
        order: 201,
        route: '/docente/aprovar-carga-horaria',
      },
      {
        displayName: '2: Aprovar relatório de atividades',
        iconName: 'gavel',
        roles: ['DOCENTE'],
        order: 202,
        route: '/docente/aprovar-relatorio-atividades',
      },
      {
        displayName: '3: Emissão certificado',
        iconName: 'fact_check',
        roles: ['DOCENTE'],
        order: 203,
        route: '/docente/emissao-certificado',
      },
      {
        displayName: 'Consulta',
        iconName: 'search',
        roles: ['DOCENTE'],
        order: 204,
        children: [
          {
            displayName: 'Planos de atividades entregues',
            iconName: 'task',
            roles: ['DOCENTE'],
            order: 205,
            route: '/docente/plano-entregue',
          },
          {
            displayName: 'Relatórios de atividades entregues',
            iconName: 'task',
            roles: ['DOCENTE'],
            order: 206,
            route: '/docente/relatorio-entregue',
          },
          {
            displayName: 'Status das inscrições',
            iconName: 'check_circle',
            roles: ['DOCENTE'],
            order: 207,
            route: '/docente/status-inscricao',
          },
        ],
      },
    ],
  },
  // STPG
  {
    displayName: 'STPG',
    iconName: 'menu',
    roles: ['STPG'],
    order: 3,
    addBottomDivider: true,
    children: [
      {
        displayName: 'Inscrições',
        iconName: 'school',
        roles: ['STPG'],
        order: 400,
        route: '/stpg/inscricoes',
      },
      {
        displayName: 'Status das inscrições',
        iconName: 'check_circle',
        roles: ['STPG'],
        order: 401,
        route: '/stpg/status-inscricao',
      },
    ],
  },
  // DISCENTE
  {
    displayName: 'Discente',
    iconName: 'menu',
    roles: ['DISCENTE'],
    order: 4,
    addBottomDivider: true,
    children: [
      {
        displayName: 'Informações e procedimentos',
        iconName: 'content_paste',
        roles: ['DISCENTE'],
        order: 300,
        route: '/discente/informacao-procedimento',
      },
      {
        displayName: '1: Inscrição',
        iconName: 'drive_file_rename_outline',
        roles: ['DISCENTE'],
        order: 301,
        route: '/discente/inscricao',
      },
      {
        displayName: '2: Modelo plano de atividades',
        iconName: 'content_copy',
        roles: ['DISCENTE'],
        order: 302,
        route: '/discente/modelo-plano-atividades',
      },
      {
        displayName: '3: Lançar carga horária',
        iconName: 'more_time',
        roles: ['DISCENTE'],
        order: 303,
        route: '/discente/carga-horaria',
      },
      {
        displayName: '4: Entregar plano de atividades',
        iconName: 'file_upload',
        roles: ['DISCENTE'],
        order: 304,
        route: '/discente/entregar-plano-atividade',
      },
      {
        displayName: '5: Modelo relatório de atividades',
        iconName: 'content_copy',
        roles: ['DISCENTE'],
        order: 305,
        route: '/discente/modelo-relatorio-atividades',
      },
      {
        displayName: '6: Entregar relatório de atividades',
        iconName: 'file_upload',
        roles: ['DISCENTE'],
        order: 306,
        route: '/discente/entregar-relatorio-atividade',
      },
      {
        displayName: '7: Emissão do certificado',
        iconName: 'fact_check',
        roles: ['DISCENTE'],
        order: 307,
        route: '/discente/emissao-certificado',
      },
      {
        displayName: 'Status das inscrições',
        iconName: 'check_circle',
        roles: ['DISCENTE'],
        order: 308,
        route: '/discente/status-inscricao',
      },
    ],
  },
  // PROPG
  {
    displayName: 'Inscrições',
    iconName: 'school',
    roles: ['PROPG'],
    order: 500,
    route: '/propg/inscricoes',
  },
  {
    displayName: 'Status das inscrições',
    iconName: 'check_circle',
    roles: ['PROPG'],
    order: 501,
    route: '/propg/status-inscricao',
  },
  {
    displayName: 'Aluno PAADES - SISGRAD',
    iconName: 'badge',
    roles: ['PROPG'],
    order: 502,
    route: '/propg/aluno-paades',
  },
  {
    displayName: 'Pesquisa de Usuário',
    iconName: 'search',
    roles: ['PROPG'],
    order: 503,
    route: '/propg/pesquisa-usuario',
  },
  {
    displayName: 'Pesquisa de Departamento',
    iconName: 'search',
    roles: ['PROPG'],
    order: 504,
    route: '/propg/pesquisa-departamento',
  },
  {
    displayName: 'Perfis',
    iconName: 'person_pin',
    roles: ['PROPG'],
    order: 505,
    route: '/propg/perfil',
  },
  {
    displayName: 'LOGs',
    iconName: 'history',
    roles: ['PROPG'],
    order: 506,
    route: '/propg/consulta-log',
    addBottomDivider: true,
  },
  // CONSULTA
  {
    displayName: 'Status das inscrições',
    iconName: 'check_circle',
    roles: ['CONSULTA'],
    order: 601,
    route: '/consulta/status-inscricao',
  },
  // COUMN
  {
    displayName: 'Manual departamento',
    iconName: 'picture_as_pdf',
    roles: ['DEPARTAMENTO'],
    order: 993,
    route: '/manual/departamento',
  },
  {
    displayName: 'Manual discente',
    iconName: 'picture_as_pdf',
    roles: ['DISCENTE'],
    order: 994,
    route: '/manual/discente',
  },
  {
    displayName: 'Manual docente',
    iconName: 'picture_as_pdf',
    roles: ['DOCENTE'],
    order: 995,
    route: '/manual/docente',
  },
  {
    displayName: 'Manual STPG',
    iconName: 'picture_as_pdf',
    roles: ['STPG'],
    order: 996,
    route: '/manual/stpg',
  },
  {
    displayName: 'Manual PROPG',
    iconName: 'picture_as_pdf',
    roles: ['PROPG'],
    order: 997,
    route: '/manual/propg',
  },
  {
    displayName: 'GUIA',
    iconName: 'picture_as_pdf',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: '/ajuda/guia',
    order: 998,
  },
  {
    displayName: 'Normas',
    iconName: 'description',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: '/normas',
    order: 999,
  },
  {
    displayName: 'Ajuda/Suporte',
    iconName: 'contact_support',
    roles: ['DEPARTAMENTO', 'ASSESSOR', 'DOCENTE', 'DISCENTE', 'STPG', 'PROPG', 'CONSULTA'],
    route: '/ajuda/suporte',
    order: 1000,
  },
  {
    displayName: 'Versões do sistema',
    iconName: 'info',
    roles: ['DEPARTAMENTO', 'ASSESSOR', 'DOCENTE', 'DISCENTE', 'STPG', 'PROPG', 'CONSULTA'],
    route: '/changelog',
    order: 1001,
  },  
  {
    displayName: 'Voltar ao portal',
    iconName: 'home',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: '/central-acessos-home',
    order: 1002,
  },
  {
    displayName: 'Autenticidade do certificado',
    iconName: 'qr_code_scanner',
    roles: [ROLE_WILDCARD_PUBLIC],
    route: '/autenticidade-certificado',
    order: 1003,
    addTopDivider: true,
  },
]
